import React from "react";
import { Slider } from "@mui/material";

const ProgressSlider = ({ position, duration, onChange, disabled }) => {
  return (
    <Slider
      value={position}
      max={duration || 100}
      onChange={onChange}
      sx={{ mx: 2 }}
      disabled={disabled}
    />
  );
};

export default ProgressSlider;
